import React, { useState, useEffect, useMemo, useRef } from "react";
import axios from "axios";
import CustomDropdown from "../../CustomControls/dropdown";
import ErrorModal from "../Security/ErrorModal";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as UTIF from "utif";
import * as pdfjsLib from "pdfjs-dist";
import  loadImage  from "image-promise"; // For JPEG, PNG, BMP
import { useNavigate } from "react-router-dom";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import { setDocusignData } from '../../Redux/docusignReducer';
import {toast , ToastContainer} from 'react-toastify';  
import { Trans } from "react-i18next";

pdfjsLib.GlobalWorkerOptions.workerSrc =
  `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const NO_CURRENCIES_MESSAGE = "No currency available. Please try again later.";
const formatCurrencyOption = (currencyOption) =>
  [currencyOption.ID, currencyOption.Text]
    .map((value) => value === undefined || value === null ? "" : String(value).trim())
    .filter(Boolean)
    .join(" - ");

const WINPayTreatmentwithCard = () => {
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [serviceTypeOptions, setServiceTypeOptions] = useState([]);
  const [selectedServiceType, setSelectedServiceType] = useState("");
  const [isServiceTypeListOpen, setIsServiceTypeListOpen] = useState(true);
  const [currentService, setCurrentService] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [fileToDeleteIndex, setFileToDeleteIndex] = useState(null);
  const [physicianName, setPhysicianName] = useState("");
  const [physicianTel, setPhysicianTel] = useState("");
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [isAddRow, setIsAddRow] = useState(false); // Boolean to handle Add Row modal
  const [formErrors, setFormErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showFileDeleteModal, setFileDeleteModal] = useState(false);
  const [showDocusignModal, setShowDocusignModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const fileInputRef = useRef(null);
  const token = localStorage.getItem("AccessToken");
  const userInfo = useSelector((state) => state.userData);
  const [physicianNameLabel, setPhysicianNameLabel] = useState("");
  const [physicianTelLabel, setPhysicianTelLabel] = useState("");
  const [isAgency, setIsAgency] = useState(false);
  const [reimbursementDocument, setReimbursementDocument] = useState(null);
  const [providerOptions, setProviderOptions] = useState([]);
  const [filteredProviderOptions, setFilteredProviderOptions] = useState([]);
  const [showProviderDropdown, setShowProviderDropdown] = useState(false);
  const [hasShownGroupValidation, setHasShownGroupValidation] = useState(false);
  const [groupOptions, setGroupOptions] = useState([]);
  const [filteredGroupOptions, setFilteredGroupOptions] = useState([]);
  const [showGroupDropdown, setShowGroupDropdown] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [isItemsLoading, setIsItemsLoading] = useState(false);
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [currencies, setCurrencies] = useState([]);
  const [isCurrenciesLoading, setIsCurrenciesLoading] = useState(false);
  const [isDocsUploading, setIsDocUploading] = useState(false);
  const dispatch = useDispatch();

  const navigate=useNavigate();
  const [tableRows, setTableRows] = useState([
    { date: "", description: "", currency: "", amount: "",isEditable: true, isCurrencyDisabled: false, },
  ]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [totalAmount, setTotalAmount] = useState("0.00");
  const [rowToDelete, setRowToDelete] = useState(null);

  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const companyName = localStorage.getItem("employer");
  const currencyOptions = useMemo(
    () => currencies.map(formatCurrencyOption),
    [currencies]
  );
  const highmarkCurrency = useMemo(
    () => currencies.find((item) =>
      item.Text === "United States Dollar" ||
      String(item.ID).toUpperCase() === "USD" ||
      String(item.Tag || "").toUpperCase() === "USD"
    ),
    [currencies]
  );

  const getPageCount = (file) => {
      return new Promise(async (resolve, reject) => {
          const bytes = await file.arrayBuffer()
          
          const loadingTask = pdfjsLib.getDocument({
              data: bytes,
              disableWorker: true});
            try {
              const pdf = await loadingTask.promise;
              const pages = pdf.numPages;
              resolve(pages);
            } catch (error) {
              reject(error);
          }
      });
  };

  const handleInputChange = (index, field, value) => {
    const updatedRows = tableRows.map((row, i) => {
      if (i === index && row.isEditable) {
        // Allow updates only if the field is not disabled
        if (field === "currency" && row.isCurrencyDisabled) return row;
  
        const updatedValue = field === "amount" ? sanitizeAmountInput(value) : value;
        return { ...row, [field]: updatedValue };
      }
      return row;
    });
  
    setTableRows(updatedRows);
    calculateTotalAmount(updatedRows);
  };
  
  const fetchGroupDetails = async (name = "") => {
        const params = {
            EmailID: userInfo.userData.EmailID,
            DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
            GroupName: name || "",
            Contract: userInfo.userData.ContractIdentified,
            Country: "",
        };

        try {
            const response = await axios.post(
                Endpoints.GetGroupDetails,
                { _Params: JSON.stringify(params) },
                {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Connection": "close",
                    "Accept": "*/*",
                    Authorization: `Bearer ${token}`,
                },
                }
            );

            const responseData = Array.isArray(response.data) ? response.data : [];

            if (responseData) {
                setGroupOptions(responseData);
                setFilteredGroupOptions(
                    responseData.filter(opt =>
                    opt.GroupName.toLowerCase().includes(name.toLowerCase()))
                );
            } else {
                setGroupOptions([]);
                setFilteredGroupOptions([]);
            }
        } catch (error) {
            setGroupOptions([]);
            setFilteredGroupOptions([]);
        }
  }; 

  const handleAddRow = () => {
    const lastRow = tableRows[tableRows.length - 1];
  
    // Validate the last row before adding a new one
    if (!lastRow || !lastRow.date || !lastRow.description || !lastRow.currency || !lastRow.amount) {
      setModalMessage(t("twtablevalid"));
      setIsAddRow(true);
      setShowModal(true);
      return;
    }
  
 // Mark the last row as non-editable and ensure the currency remains disabled
 const updatedRows = tableRows.map((row, index) =>
    index === tableRows.length - 1
      ? { ...row, isEditable: false, isCurrencyDisabled: true }
      : row
  );

  
    // Add a new row with isEditable set to true
    setTableRows([
        ...updatedRows,
        { 
          date: "", 
          description: "", 
          currency: lastRow.currency, // Forward the currency
          amount: "", 
          isEditable: true, 
          isCurrencyDisabled: true // Disable currency field in the new row
        },
      ]);
           

  };
  
  const handleDeleteRow = (index) => {
    if (tableRows.length === 1) {
      // Reset the single row to an empty editable row instead of deleting it
      setTableRows([
        { date: "", description: "", currency: isHighmarkPortal && highmarkCurrency ? formatCurrencyOption(highmarkCurrency) : "", amount: "", isEditable: true },
      ]);
      setUploadedFiles([]); // Clear uploaded files
      setTotalAmount("0.00"); // Reset total amount
    } else {
      const updatedRows = tableRows.filter((_, i) => i !== index);
      setTableRows(updatedRows);
      calculateTotalAmount(updatedRows);
    }
  };
  

   const confirmDeleteRow = () => {
    if (rowToDelete !== null) {
      const updatedRows = tableRows.filter((_, i) => i !== rowToDelete);
      setTableRows(updatedRows);
      calculateTotalAmount(updatedRows);
      setRowToDelete(null);
    }
    setShowDeleteModal(false);
   
  };

  const calculateTotalAmount = (rows) => {
    const total = rows.reduce((sum, row) => {
      const sanitizedAmount = row.amount ? row.amount.replace(/,/g, "") : "0"; // Remove commas
      return sum + (parseFloat(sanitizedAmount) || 0);
    }, 0);
  
    // Format total with commas and two decimal places
    const formattedTotal = total.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  
    setTotalAmount(formattedTotal);
  };
  
  useEffect(() => {
    const fetchServiceTypes = async () => {
      setIsItemsLoading(true);
      try {
        const response = await axios.post(
         Endpoints.LoadServiceType,
          new URLSearchParams({
            _Params: JSON.stringify({
              MemberID: userInfo.userData.MemberID,
              Contract: userInfo.userData.ContractIdentified,
              DeviceType:isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
              EmailID:userInfo.userData.EmailID,
              ContractCode: 0,
              URL: null,
              Room: null,
              Name: null,
            }),
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`
            },
          }
        );

        const uniqueServiceTypes = Array.from(
          new Map(response.data.map((item) => [item.Text, item])).values()
        );
        setServiceTypeOptions(uniqueServiceTypes);
      } catch (error) {
        console.error(error);
      } finally {
        setIsItemsLoading(false);
      }
    };
    fetchServiceTypes();
  }, []);

  useEffect(() => {
    const fetchCurrencies = async () => {
      const deviceType = isHighmarkPortal ? "HighmarkPortal" : "PatientPortal";
      setIsCurrenciesLoading(true);

      try {
        const response = await axios.post(
          Endpoints.LoadCurrencies,
          new URLSearchParams({
            _Params: JSON.stringify({
              EmailID: userInfo.userData.EmailID,
              DeviceType: deviceType,
            }),
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const currencyData = Array.isArray(response.data) ? response.data : [];
        setCurrencies(
          currencyData.filter(
            (item) => item && formatCurrencyOption(item)
          )
        );
      } catch (error) {
        console.error("Error fetching currencies:", error);
        setCurrencies([]);
      } finally {
        setIsCurrenciesLoading(false);
      }
    };

    fetchCurrencies();
  }, [isHighmarkPortal, token, userInfo.userData.EmailID]);

  useEffect(() => {
    if (isHighmarkPortal && !isCurrenciesLoading) {
      setTableRows((rows) =>
        rows.map((row) => ({
          ...row,
          currency: highmarkCurrency ? formatCurrencyOption(highmarkCurrency) : "",
          isCurrencyDisabled: Boolean(highmarkCurrency),
        }))
      );
    }
  }, [highmarkCurrency, isCurrenciesLoading, isHighmarkPortal]);

  const handleFileChange = (event) => {
    const files = event.target.files;
    if((files.length + uploadedFiles.length)>4) return toast.error("Maximum 4 files are allowed");
    const validExtensions = ["pdf", "tiff", "jpeg", "jpg", "bmp", "png"];

    let duplicateFound = false;

    // Check for duplicates with already uploaded files
    for (const file of files) {
      const isDuplicate = uploadedFiles.some(
        f => f.name === file.name && f.size === file.size
      );
      if (isDuplicate) {
        duplicateFound = true;
        break;
      }
    }

    // Check for duplicates within the new files themselves
    const fileSignatures = new Set();
    for (const file of files) {
      const signature = `${file.name}_${file.size}`;
      if (fileSignatures.has(signature)) {
        duplicateFound = true;
        break;
      }
      fileSignatures.add(signature);
    }

    if (duplicateFound) {
      toast.error("Duplicate file(s) detected. Please select unique files only.");
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    Array.from(files).forEach(file => {
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (file.size > 5 * 1024 * 1024) {
        setModalMessage(`The ${file.name} is too large (over 5MB). Please upload a smaller file.`);
        setShowModal(true);
      } else if (validExtensions.includes(fileExtension) && file.size < 2 * 1024 * 1024 && !duplicateFound) {
        setUploadedFiles(prev => [...prev, file]);
        setFormErrors((prevErrors) => ({ ...prevErrors, files: "" }));
      } else {
        setModalMessage(t("invalidfiletype"));
        setShowModal(true);
      }
    });
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleDeleteFile = () => {
    setUploadedFiles((prev) => prev.filter((_, index) => index !== fileToDeleteIndex));
    setFileToDeleteIndex(null);
    setFileDeleteModal(false);
  };

  const confirmDeleteFile = (index) => {
    setFileToDeleteIndex(index);
    setModalMessage(t("deletefilevalid"));
    setFileDeleteModal(true);
  };


  const handleSubmit = async () => {
    const errors = {};
    if (!selectedServiceType) errors.serviceType = t("servicetypevalid");
    if (!uploadedFiles.length) errors.files =t("filevalid");
    if (!physicianName) errors.physicianName = isAgency? t("Agencynamevalid"):t("Physiciannamevalid");
    if (!physicianTel) errors.physicianTel = isAgency? t("Agencytelvalid"):t("Physiciantelvalid");
    if (!isAgency && !groupName) errors.groupName = t("Groupnamevalid");
    // Validate table rows
  const validRows = tableRows.filter(
    (row) =>
      row.date &&
      row.description &&
      row.currency &&
      row.amount
  );

  if (validRows.length === 0) {
    errors.table = t("tablevalid");
  }

  setFormErrors(errors);
    if (!checkboxChecked) errors.checkbox = t("termsandconditionsvalid");
  
    setFormErrors(errors);
    setIsFormSubmitted(true); // Set form as submitted
    if (Object.keys(errors).length === 0) {
      try {
        // Upload files and get their paths
        const filePaths = await uploadFiles();
        // Call SendToWin method with the obtained file paths
        await sendToWinOrFetchReimbursement(filePaths);
        if(isAgency) {
          await ReimbursementProviderDetails(physicianName, selectedServiceType);
        }
  
      } catch (error) {
        console.error(error);
      }
    }
  };

  const ReimbursementProviderDetails = async(name = "", serviceType = "") => {
    const params = {
       EmailID: userInfo.userData.EmailID,
       DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
       GroupName: name ? name : "",
       ServiceType: serviceType || ""
    };
    try {
        const response = await axios.post(
            Endpoints.ReimbursementProviderDetails,
            { _Params: JSON.stringify(params) ,
                _DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
           },
           {
               headers: {
                 "Content-Type": "application/x-www-form-urlencoded",
                 "Accept": "*/*",
                 Authorization: `Bearer ${token}`,
               },
            }
        );
        if (!name) {
            if (response.data && response.data.ProviderDetailsList ) {
                setProviderOptions(response.data.ProviderDetailsList);
                // Filter options to match input
                setFilteredProviderOptions(
                    response.data.ProviderDetailsList.filter(opt =>
                        opt.GroupName.toLowerCase().includes((name || '').toLowerCase())
                    )
                );
            } else {
                setProviderOptions([]);
                setFilteredProviderOptions([]);
            }
        } else {
            if(response.data.group_id_created){
                return;
            } else {
                console.error("Error occured while saving name");
            }
        }
    } catch (error) {
        setProviderOptions([]);
        setFilteredProviderOptions([]);
        console.error("No data received from the reimbursement provider.", error);
    }

};

 const calculateNoOfPages = async (file, fileType) => {
  try {
    if (fileType === "application/pdf") {
       return await getPageCount(file);
    } else if (fileType === "image/tiff") {
        const buffer = await file.arrayBuffer();
        const pages = UTIF.decode(buffer); // Decode TIFF file
        return pages.length; // Number of pages in the TIFF file
      } else if (
      fileType === "image/jpeg" ||
      fileType === "image/png" ||
      fileType === "image/bmp"
    ) {
      await loadImage(URL.createObjectURL(file));
      return 1; // Single-page image
    }
  } catch (error) {
    console.warn(`Error determining page count for ${file.name}:`, error);
  }
  return 1; // Default to 1 if unable to determine
};

  const sendToWinOrFetchReimbursement = async (filePaths, isFetchReimbursement) => {
    const documents = await Promise.all(
      filePaths.map(async (filePath, index) => {
        const file = uploadedFiles[index];
        const fileType = file.type;
  
        // Use shared function to calculate the number of pages
        const noOfPages = await calculateNoOfPages(file, fileType);
  
        return {
          FileID: (index + 1).toString(),
          FilePath: filePath || "", // Add FilePath if available
          FileName: file.name || "Unknown",
          NoOFPages: noOfPages.toString(),
          DocTypeDesc: "",
        };
      })
    );
   
    const reimbursementDetails = tableRows
      .filter((row) => row.date && row.description && row.currency && row.amount)
      .map((row) => ({
        DateIncurred: row.date.toLocaleDateString("en-US"),
        ServiceName: row.description,
        Currency: row.currency,
        Amount: parseFloat(row.amount.replace(/,/g, ""))
      }));
  
    // Calculate total amount
    const totalAmount = reimbursementDetails.reduce((sum, item) => sum + item.Amount, 0);
    const totalFiles = documents.length;
  
    // Prepare the payload
    const payload = {
      _Params: JSON.stringify({
        DocumentTypes: [],
        MemberID: userInfo.userData.MemberID,
        Contract: userInfo.userData.ContractIdentified,
        DoctypeDesc: t("doctypedesc"),
        UserName: "MAPP",
        Documents: documents,
        TotalFiles: totalFiles,
        ReimbursementDetails: reimbursementDetails,
        TotalAmount: totalAmount,
        PhysicianName: physicianName,
        PhysicianTelNo: physicianTel,
        ReimbursementType: t("reimbursementtype"),
        ServiceType: currentService.AuthNo == 0 || !currentService.Tag ? currentService.Text : currentService.Tag,
        DeviceType:isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
        EmailID:userInfo.userData.EmailID,
        ProviderID:"",
        GroupID:"",
        Speciality:"",
        Activity:"",
        GroupName: groupName,
        AuthNo: currentService.Authno === 0 ? "" : currentService.Authno,
        DisplayContract: userInfo.userData.Employer || "",
      }),
    };
    // Determine the endpoint dynamically
    const endpoint = 
    //    isFetchReimbursement ? Endpoints.SendToWin : 
       Endpoints.FetchReimbursement

    try {
      // Make the API call
      const response = await axios.post(endpoint, payload, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      });
  
      // Handle success
      if (response.status === 200) {
        dispatch(setDocusignData(response.data));
        if (response.data) {
            const fetchedDoc = response.data.Documents.find(
                (doc) => doc.DocTypeDesc === "Reimbursement Form"
              );
              if (fetchedDoc) {
                setReimbursementDocument({
                  FileID: fetchedDoc.FileID,
                  FilePath: fetchedDoc.FilePath,
                  FileName: fetchedDoc.FileName,
                  NoOFPages: fetchedDoc.NoOFPages.toString(),
                  DocTypeDesc: fetchedDoc.DocTypeDesc,
                });
              }
            }
        setModalMessage(t("docusignmes"));
        setShowDocusignModal(true);
      } else {
        console.error(response.status, response.data);
        setModalMessage("Failed to process the request. Please try again.");
        setShowModal(true);
        return { success: false, error: response.data };
      }
    } catch (error) {
      console.error("Request Failed:", error.message);
      setModalMessage("An error occurred while processing the request.");
      setShowModal(true);
      return { success: false, error: error.message };
    }
  };
  
  const uploadFiles = async () => {
    let fileID = 1;
    const payloads = [];
  
    for (const file of uploadedFiles) {
      const fileType = file.type;
  
      // Calculate the number of pages
      const noOfPages = await calculateNoOfPages(file, fileType);
  
      const fileToBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result.split(",")[1]);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(file);
        });
  
      // Convert file to Base64
      const base64Data = await fileToBase64(file);
  
      // Create payload
      const filePayload = {
        FileID: fileID.toString(),
        FilePath: "",
        FileName: file.name,
        NoOFPages: noOfPages.toString(),
        DocTypeDesc: "",
        inputBytes: base64Data,
        fileSize: file.size.toString(),
        memberId: userInfo.userData.MemberID,
        contract: userInfo.userData.ContractIdentified,
        contractCode: "",
        docTypeDescription: selectedServiceType,
        DeviceType:isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
        EmailID:userInfo.userData.EmailID
      };
  
      payloads.push(filePayload);
      fileID++;
    }

    setLoading(true);
    setIsDocUploading(true);
    // API call
    const response = await axios.post(
      Endpoints.UploadDocument,
      JSON.stringify(payloads),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    setLoading(false);
    setIsDocUploading(false);
    return response.data.map((file) => file.FilePath);
  };

  const fetchProviders = async (groupId) => {
        try {
        const params = {
            DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
            GroupID: groupId,
            EmailID: userInfo.userData.EmailID,
            Contract: userInfo.userData.ContractIdentified,
        };
        const response = await axios.post(
            Endpoints.GetProviderDetails,
            { _Params: JSON.stringify(params) },
            {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Connection": "close",
                "Accept": "*/*",
                Authorization: `Bearer ${token}`,
            },
            }
        );
        setProviderOptions(response.data);
        } catch (error) {
        console.error("Error fetching providers:", error);
        }
    };


  const handleServiceTypeChange = (option) => {
    setGroupName("");
    setSelectedServiceType(option);
    setIsServiceTypeListOpen(false);
    const service = serviceTypeOptions.find(opt => opt.Text === option || opt.Tag === option);
    setCurrentService(service);
    setFormErrors((prevErrors) => ({ ...prevErrors, serviceType: "" }));
    setPhysicianName("");
    // Determine if Agency/Attorney labels should apply
    setIsAgency(option === "Surrogacy" || option === "Adoption");
  
    // Update labels based on the condition
    setPhysicianNameLabel(isAgency ? t("Agencyname") : t("Physicianname"));
    setPhysicianTelLabel(isAgency ? t("Agencytelname") : t("Physiciantelname"));
    ReimbursementProviderDetails("", option);
    if (isFormSubmitted) {
    if (!physicianName) formErrors.physicianName = isAgency? t("Agencynamevalid"):t("Physiciannamevalid");
    if (!physicianTel) formErrors.physicianTel = isAgency? t("Agencytelvalid"):t("Physiciantelvalid");
    }
  };

  const handleModalClose = async () => {
    // Close the modal
    setShowDocusignModal(false);
  
    // Dynamically determine base URL and return URL
    const baseUrl = window.location.origin;
    const returnUrl = `${baseUrl}/docusignthankyou`;
  
    // Prepare the payload
    const objDocusignInput = {
      ReceiverEmail: userInfo.userData.EmailID,
      ReceiverProfileName: `${userInfo.userData.FirstName} ${userInfo.userData.LastName}`,
      DocumentName: "Reimbursement Form",
      DocumentPath: reimbursementDocument.FilePath,
      BaseUrl: baseUrl,
      ReturnUrl: returnUrl,
      Sign_Page_Number: "2",
      Sign_X_Width: "610",
      Sign_Y_Height: "450",
      DeviceType:isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
    };
  
    try {
      // Convert the payload into a single JSON-encoded query parameter
      const encodedParams = encodeURIComponent(JSON.stringify(objDocusignInput));
      const url = `${Endpoints.GetSigningDocument}?_Params=${encodedParams}`;
  
      // Make the GET request
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (response.status === 200 && response.data) {
        const redirectUrl = response.data;

    if (redirectUrl) {
        navigate("/docusign", { state: { redirectUrl} });
    }
}
    } catch (error) {
      console.error("Error calling Docusign API:", error);
    }
  };
  
const sanitizeAmountInput = (value) => {
    // Allow only numbers and a single dot
    let sanitizedValue = value.replace(/[^0-9.]/g, "");
  
    // Prevent multiple dots
    const dotCount = (sanitizedValue.match(/\./g) || []).length;
    if (dotCount > 1) {
      sanitizedValue = sanitizedValue.substring(0, sanitizedValue.lastIndexOf("."));
    }
  
    // Split into integer and decimal parts
    const [integerPart, decimalPart] = sanitizedValue.split(".");
  
    // Format the integer part with commas
    const formattedInteger = integerPart
      ? parseInt(integerPart, 10).toLocaleString("en-US")
      : "";
  
    // Combine integer and decimal part dynamically
    let formattedValue = decimalPart !== undefined
      ? `${formattedInteger}.${decimalPart.slice(0, 2)}`
      : formattedInteger;
  
    // Remove unnecessary leading zeros, except when starting with "0."
    if (formattedValue.startsWith("0") && !formattedValue.startsWith("0.") && formattedValue.length > 1) {
      formattedValue = formattedValue.replace(/^0+/, "");
    }
  
    return formattedValue;
  };
  
const onBrowse = () => {
    const input = document.getElementById('fileInput');
    if (input) {
        input.value = null; // Always reset so change event fires even for same file
        input.click();
    }
}; 
  
const handleBackClick = () => {
    navigate(-1);
};

  const selectedServiceOption = serviceTypeOptions.find(
    (option) => option.Text === selectedServiceType
  );

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading mb-2"></div>
            <h2 className="loading-text">
            {!isDocsUploading ? (
                t("loading")
            ) : (
                <>
                Your documents are being securely uploaded.
                <br />
                Please wait for a moment.
                </>
            )}
            </h2>            
      </div>
      );
  }

  return (
    <>
       <ToastContainer />
       {isHighmarkPortal ? 
            <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
            <button className="win-back-btn" onClick={handleBackClick}>
                <span>
                <i className="bi bi-chevron-left"></i>
                </span>
            </button>       
            <h2 className="page-heading">{t('titlepayment')}</h2>
            </div>:
            <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
            <button className="win-back-btn" onClick={handleBackClick}>
                <span>
                <i className="bi bi-chevron-left"></i>    
                {t('Back')}        
                </span>
            </button>       
            <h2 className="page-heading">{t('titlepayment')}</h2>
            </div>
          }
  
  <ErrorModal
    show={showFileDeleteModal}
    message={modalMessage}
    onClose={() => setFileDeleteModal(false)}
    onOkay={handleDeleteFile}
    showConfirmButtons={true}
  />

  <ErrorModal
    show={showModal}
    message={modalMessage}
    onClose={() => setShowModal(false)}
    closeButton={true}
  />
  <ErrorModal
    show={showDocusignModal}
    message={modalMessage}
    onClose={handleModalClose}
    closeButton={true}
  />

      <ErrorModal
        show={showDeleteModal}
        message={modalMessage}
        onClose={() => setShowDeleteModal(false)}
        onOkay={confirmDeleteRow}
        showConfirmButtons={true}
      />

      
      <div className="col-md-12 text-center mb-5">
      <b>
        {isHighmarkPortal 
          ? "I would like to pay for a treatment with Fertility and Family Building Card" 
          : t("paymentsubtitle")}
      </b>
        </div>

      <div className="col-md-6 ">
            <div className="mb-3 row flex-sm-row flex-column">
                <div class="col-12">
                <label className="form-label win-form-label mt-2">{t("servicetype")}</label>
                </div>
                      
                <div class="col-12">
                    <div className="supporting-service-options" role="radiogroup" aria-label={t("servicetype")}>
                      {isItemsLoading ? (
                        <div className="supporting-service-loading" aria-live="polite" aria-label={t("loading")}>
                          <div className="supporting-service-spinner" />
                        </div>
                      ) : selectedServiceOption && !isServiceTypeListOpen ? (
                        <button
                          type="button"
                          className="supporting-service-selected-summary"
                          onClick={() => setIsServiceTypeListOpen(true)}
                          aria-expanded={isServiceTypeListOpen}
                        >
                          <span className="supporting-service-selected-summary-header">
                            <span className="supporting-service-option-title">{selectedServiceOption.Text}</span>
                            <i className="bi bi-chevron-down supporting-service-selected-summary-icon" aria-hidden="true"></i>
                          </span>
                          {selectedServiceOption.DateRange && (
                            <span className="supporting-service-selected-summary-date">{selectedServiceOption.DateRange}</span>
                          )}
                        </button>
                      ) : (
                        serviceTypeOptions.map((option) => (
                          <button
                            key={option.Value ?? option.Tag ?? option.Text}
                            type="button"
                            className={`supporting-service-option supporting-service-option--single-line${selectedServiceType === option.Text ? " selected" : ""}`}
                            onClick={() => handleServiceTypeChange(option.Text)}
                            aria-pressed={selectedServiceType === option.Text}
                          >
                            <span className="supporting-service-option-title">{option.Text}</span>
                            {option.DateRange && (
                              <span className="supporting-service-option-date">{option.DateRange}</span>
                            )}
                          </button>
                        ))
                      )}
                    </div>

                    <div className="form-field-error-message">
                    {formErrors.serviceType && <div className="form-field-error-message">{formErrors.serviceType}</div>}
                    </div>
                </div>
            </div>        
      </div>

      <div className="col-md-6 supporting-upload-column">
        <div className="mb-3 supporting-upload-section">
            <div className="col-12 px-0">
            <label className="form-label win-form-label mandatory supporting-upload-label">{t("uploadfiles")}</label>
            </div>
            <div className="col-12 px-0 supporting-upload-field">
            <div class="custom-file-upload-c">
              <input
                type="file"
                multiple
                id="fileInput"
                class="file-input"
                onChange={handleFileChange}
                ref={fileInputRef}
                accept=".pdf, .tiff, .jpeg, .jpg, .bmp, .png"
              />
              <div class="input-display">
                <input type="text" class="file-text" placeholder={t("choosefileplaceholder")} readonly />
                <button type="button" class="custom-button"  onClick={onBrowse}>{t("browse")}</button>
              </div>
            </div>

            <div className="note-gray-bold-14" style={{ whiteSpace: "nowrap" }}>
            {t("alertfile")}
            </div>
            {formErrors.files && <div className="form-field-error-message">{formErrors.files}</div>}
            </div>
        </div> 
      </div>

      <div className="mt-5">
      <div className="form-field-error-message">{t("filevalidation")}</div>
      </div>
      <div className="mt-2 winpay-table-wrapper">
        <table className="table winpay-table">
            <thead className="winpay-table-header">
            <tr className="winpay-table-header">
                <th width="80%">{t("filenamelable")}</th>
                <th width="140" className="text-center">{t("btnview")}</th>
                <th width="140" className="text-center">{t("btndelete")}</th>
            </tr>
            </thead>
            <tbody>
            {uploadedFiles.map((file, index) => (
                <tr key={index} className="winpay-table-row">
                <td>{file.name}</td>
                <td className="text-center">
                    <a href={URL.createObjectURL(file)} target="_blank"  className="winpay-table-view-icon mx-auto" rel="noopener noreferrer">
                    {/* View */}
                    </a>
                </td>
                <td className="text-center">
                    <button className="winpay-table-trash-icon mx-auto" onClick={() => confirmDeleteFile(index)}></button>
                </td>
                </tr>
            ))}
                {uploadedFiles.length === 0 && (
                            <tr>
                                <td colSpan="3" className="text-center">
                                  {t("nofileuploaded")}
                                </td>
                            </tr>
                        )}
            </tbody>
        </table>
      </div>

      {!isAgency && (
        <div className="col-md-6">
            <div className="mb-3 row flex-sm-row flex-column">
            <div className="col-lg-4 col-md-12 col-sm-12">
                <label className="form-label win-form-label mandatory mt-2">
                Group/Hospital Name
                </label>
            </div>

            <div className="col-lg-4 col-md-12 col-sm-12">
                <div>
                <input
                    type="text"
                    className="form-control win-form-control mobile-view"
                    value={groupName}
                    autoComplete="off"
                    maxLength="100"
                    onChange={(e) => {
                        const inputValue = e.target.value;
                        setGroupName(inputValue);
                        setFormErrors((prev) => ({
                            ...prev,
                            groupName: "",
                        }));

                        if (groupOptions.length > 0) {
                            const filtered = groupOptions.filter((opt) =>
                            opt.GroupName.toLowerCase().includes(inputValue.toLowerCase())
                            );

                            setFilteredGroupOptions(filtered);
                            setShowGroupDropdown(true);
                        }
                    }}
                    onBlur={() => {
                        setTimeout(() => setShowGroupDropdown(false), 150);
                    }}
                    onFocus={() => {
                        fetchGroupDetails("");
                        setShowGroupDropdown(true);
                    }}
                />
                <div className="form-field-error-message">
                    {formErrors.groupName && <div className="form-field-error-message">{formErrors.groupName}</div>}
                </div>

                {showGroupDropdown && filteredGroupOptions.length > 0 && (
                    <ul className="dropdown-list">
                    {filteredGroupOptions.map((opt, idx) => (
                        <li
                        key={idx}
                        onMouseDown={() => {
                            setGroupName(opt.GroupName);
                            setShowGroupDropdown(false);
                            fetchProviders(opt.GroupID);
                        }}
                        >
                        {opt.GroupName}
                        </li>
                    ))}
                    </ul>
                )}
                </div>
            </div>
            </div>
        </div>
      )}

      <div className="col-md-6">
        <div className="mb-3 row flex-sm-row flex-column">
            <div class="col-lg-4 col-md-12 col-sm-12"><label className="form-label win-form-label mandatory mt-2"> {isAgency ? t("Agencyname") : t("Physicianname")}</label></div>
            <div class="col-lg-7 col-md-12 col-sm-12">
            {isAgency ? (
                        <div>
                            <input
                                type="text"
                                className="form-control win-form-control"
                                id="providerNameDropdown"
                                value={physicianName}
                                autoComplete="off"
                                maxLength="100"
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                    setPhysicianName(inputValue);
                                    setFormErrors((prevErrors) => ({ ...prevErrors, physicianName: "" }));
                                    if (isAgency) {
                                        if (providerOptions.length > 0) {
                                            setFilteredProviderOptions(
                                                providerOptions.filter(opt =>
                                                    opt.GroupName.toLowerCase().includes((inputValue || '').toLowerCase())
                                                )
                                            );
                                            setShowProviderDropdown(true);
                                        } else {
                                        }
                                    }
                                }}
                                onBlur={() => {
                                    setTimeout(() => setShowProviderDropdown(false), 150); // Delay to allow click
                                }}
                                onFocus={() => {
                                    if (filteredProviderOptions.length > 0) setShowProviderDropdown(true);
                                }}
                            />
                            {showProviderDropdown && filteredProviderOptions.length > 0 && (
                                <ul className="dropdown-list">
                                    {filteredProviderOptions.map((opt, idx) => (
                                        <li
                                            key={idx}
                                            onMouseDown={() => {
                                                setPhysicianName(opt.GroupName);
                                                setFormErrors((prevErrors) => ({ ...prevErrors, physicianName: "" }));
                                                setShowProviderDropdown(false);
                                                setProviderOptions([]);
                                                setFilteredProviderOptions([]);
                                            }}
                                        >
                                            {opt.GroupName} ({opt.NetworkType})
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ) : (
                        <div>
                        <input
                            type="text"
                            className="form-control win-form-control mobile-view"
                            value={physicianName}
                            autoComplete="off"
                            maxLength="100"
                            onChange={(e) => {
                                if (!groupName) {
                                    setModalMessage("Please select a group before selecting a physician.");
                                    setShowValidationModal(true);
                                    return;
                                }

                                const inputValue = e.target.value;
                                setPhysicianName(inputValue);

                                setFormErrors((prev) => ({
                                    ...prev,
                                    physicianName: "",
                                }));

                                if (providerOptions.length > 0) {
                                    const filtered = providerOptions.filter((opt) =>
                                        opt.ProName.toLowerCase().includes(inputValue.toLowerCase())
                                    );

                                    setFilteredProviderOptions(filtered);
                                    setShowProviderDropdown(true);        
                                }
                            }}
                            onBlur={() => {
                                setTimeout(() => setShowProviderDropdown(false), 150);
                            }}
                            onFocus={() => {
                                setFilteredProviderOptions(providerOptions);
                                if (!groupName && !hasShownGroupValidation) {
                                    setModalMessage("Please select a group before selecting a physician.")
                                    setShowValidationModal(true);
                                    setHasShownGroupValidation(true);
                                } else {
                                    setShowProviderDropdown(true);
                                }
                            }}
                        />
                        <div className="form-field-error-message">
                            {formErrors.physicianName && <div className="form-field-error-message">{formErrors.physicianName}</div>}
                        </div>

                        {showProviderDropdown && filteredProviderOptions.length > 0 && (
                            <ul className="dropdown-list">
                            {filteredProviderOptions.map((opt, idx) => (
                                <li
                                key={idx}
                                onMouseDown={() => {
                                    setPhysicianName(opt.ProName);
                                    setShowProviderDropdown(false);
                                }}
                                >
                                {opt.ProName}
                                </li>
                            ))}
                            </ul>
                        )}
                    </div>
                    )}
            </div>
        </div>
      </div>

      <div className="col-md-6">
        <div className="mb-3 row flex-sm-row flex-column">

          <div className="col-lg-4 col-md-12 col-sm-12">
            <label className="form-label win-form-label mt-2">
              {isAgency ? t("Agencytelname") : t("Physiciantelname")}
            </label>
          </div>

          <div className="col-lg-4 col-md-12 col-sm-12">
            <input
              type="text"
              className="form-control win-form-control mobile-view"
              value={physicianTel}
              onChange={(e) => {
                if (/^\d*$/.test(e.target.value)) {
                  setPhysicianTel(e.target.value);
                }
              }}
            />
          </div>

        </div>
      </div>
      <div className="mt-5 winpay-table-wrapper min-height-to-show-dropdown-values">
      <table className="table winpay-table">
        <thead className="winpay-table-header">
          <tr>
            <th width="200" className="ps-3">{t("datetbl")}</th>
            <th className="ps-3">{t("descriptiontbl")}</th>
            <th width="240" className="ps-3">{t("currencytbl")}</th>
            <th width="200" className="ps-3">{t("amounttbl")}</th>
            <th width="140" className="text-center">{t("actionstbl")}</th>
          </tr>
        </thead>
        <tbody>
  {tableRows.map((row, index) => (
    <tr key={index}>
      <td>
        <DatePicker
          selected={row.date ? new Date(row.date) : null}
          onChange={(date) => handleInputChange(index, "date", date)}
          dateFormat="MM/dd/yyyy"
          placeholderText="MM/DD/YYYY"
          className="custom-datepicker form-control win-form-control w-100-percent calendar-control"
          onKeyDown={(e) => e.preventDefault()}
          popperPlacement="bottom-start"
          disabled={!row.isEditable}
          showYearDropdown
          scrollableYearDropdown
        />
      </td>
      <td>
        <input
          type="text"
          className="form-control win-form-control w-100-percent"
          value={row.description}
          onChange={(e) => handleInputChange(index, "description", e.target.value)}
          disabled={!row.isEditable}
        />
      </td>
      <td className="custom-dropdown-width-controll">
        <CustomDropdown
          options={currencyOptions}
          selectedOption={row.currency}
          onChange={(option) => handleInputChange(index, "currency", option)}
          placeholder= {t("currencyplaceholder")}
          disabled={!row.isEditable || row.isCurrencyDisabled} // Check if currency is disabled
          searchable={true}
          isLoading={isCurrenciesLoading}
          noOptionsMessage={NO_CURRENCIES_MESSAGE}
        />
      </td>
      <td>
      <input
        type="text"
        className="form-control win-form-control w-100-percent"
        value={row.amount}
        onChange={(e) => handleInputChange(index, "amount", e.target.value)}
        onPaste={(e) => e.preventDefault()} // Prevent pasting invalid values
        disabled={!row.isEditable}
        inputMode="decimal" // Ensures numeric keyboard for mobile devices
      />
      </td>
      <td align="center">
        <button
          className="win-btn-secondary-winpay-gird"
          onClick={() => handleDeleteRow(index)}
        >
         {t("removebtn")}
        </button>
      </td>
    </tr>
  ))}

</tbody>

        <tfoot>
          <tr className="winpay-table-row">
            <td colSpan="3">{t("totalrequestedamount")}</td>
            <td className="ps-4">{totalAmount}</td>
            <td align="center">
              <button className="win-btn-primary-winpay-gird" onClick={handleAddRow}>
              {t("addrow")}
              </button>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    {formErrors.table && <div className="form-field-error-message">{formErrors.table}</div>}


      <div className="col-12 d-flex mt-sm-0 mt-md-5 mb-5">
        <input
          type="checkbox"
          className="form-check-input radio-btn win-form-check-input mobile-view"
          checked={checkboxChecked}
          onChange={() => {
            setCheckboxChecked(!checkboxChecked);
            setFormErrors((prevErrors) => ({ ...prevErrors, checkbox: "" }));
          }}
         
        />
       <div className="note-black-14 ms-3">
        {isHighmarkPortal ? t("termsandconditionff") : (
                        <Trans
                          i18nKey="termsandcondition"
                          values={{ companyName }}
                          components={{ strong: <strong /> }}
                          />
        )}
      </div>
      </div>
      {formErrors.checkbox && <div className="form-field-error-message">{formErrors.checkbox}</div>}

      <div className="col-12 text-center mb-5">
        <button className="win-btn-primary" onClick={handleSubmit}>{t("senddocumentsbtn")}</button>
      </div>
      <ErrorModal show={showValidationModal} message={modalMessage} onClose={() => setShowValidationModal(false)} closeButton={true} />
    </>
  );
};

export default WINPayTreatmentwithCard;
